export const app = {
  p: 3,
  display: "grid",
  gridTemplateColumns: "275px 1fr 275px",
  gap: 4,
};

export const sidebar = {
  gridRow: "1 / 5",
};

export const heading = {
  gridColumn: "2 / 4",
  mb: -3,
};

export const footer = {
  gridColumn: "2 / 4",
  gridRow: "4/5",
};
